<template>
<div>

<div v-html="content" class="content"></div>
<!--<img :src="content" class="container" style="text-align:center;margin:0px;">-->
<div class="container" style="background-color:grey;">
  <div class="center">
    <button @click="redirect()" class="topUPBtn">{{btnName}}</button>
  </div>
</div>
</div>
   <!-- <div v-html="content" class="container">
text-align: center;
    </div>-->
</template>

<script>
  import StockHeader from "@/components/stockheader";

  import StockCard from "@/components/stockcard";
  import VueKline from "vue-kline";
  import $ from "jquery";
  import StockTrading from "@/components/stocktrading";
  // import Kline from 'kline';

    export default {
      name: "Popupcontent1",
      components:{
        StockHeader,
        StockCard,
        VueKline,
        StockTrading
      },
      props:['range'],
      data() {
        return {
           content:'',
          concernStatus:true,
          activityId: "",
          btnName: ""
        };
      },
      methods: {
        redirect(){
          if(this.activityId == "recharge_popup_image_pc") {
            this.$router.push({path:'/myaccount/capital'})
          } else if(this.activityId == "trading_popup_image_pc") {
            this.$router.push({
            path:"/operate/operateday"
          })
          }
        },
       getActivityDetail(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'sysconfig',
              'name': that.$route.query.activityid
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.content = resData.data;
              }else{
                that.$alert('请稍后尝试','提示',{
                  confirmButtonText: '确定',
                })
              }
            });
        }

      },
      mounted: function () {
        let that = this;
       that.getActivityDetail();
        that.activityId = that.$route.query.activityid;
         if(this.activityId == "recharge_popup_image_pc") {
            this.btnName = "立即充值";
          } else if(this.activityId == "trading_popup_image_pc") {
            this.btnName = "立即配资交易";
          }

      },


    }
</script>

<style scoped>
  .content{
    margin: 0 auto;
    text-align: center;
  }
  .content>>>img{
    width: 100%;
  }
.container .btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}
  .container {
    width: 100%;
   position: relative;

   /* max-width: 1200px;
  max-height: 250px;
    min-width: 1000px;
    margin: 10px auto;*/
  }
  .stockCard {
    height: 160px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .stockTitle{
    color: rgb(1, 39, 147);
    font-size: 24px;
    border-bottom: 2px solid rgb(1, 39, 147);
  }
  .stockSubhead{
    font-size: 12px;
  }
  .trade{
    text-align: right;
    font-size: 24px;
    border-bottom: 1px solid #EBEEF5;
    padding-top: 35px;
    padding-bottom: 10px;
  }
  .stockInfoLeft{
    border-right: 1px solid #EBEEF5;
  }
  .pricechange{
    padding-top: 35px;
    padding-bottom: 10px;
    font-size: 12px;
    border-bottom: 1px solid #EBEEF5;
  }
  .stockTime{
    padding-top: 10px;
    font-size: 12px;
    color: rgb(1, 39, 147);
    padding-bottom: 20px;
  }
  .stockInfoTitle{
    font-size: 12px;
    padding-top: 10px;
    line-height: 20px;
  }
  .text-right{
    text-align: right;
  }
  .text-left{
    text-align: left;
  }
  .green{
    color: #008000;
  }
  .stockColor{
    color: rgb(1, 39, 147);
  }
  .m-line{
    width: 100%;
    height: 500px;
  }
  .K-line{
    width: 100%;
    height: 500px;
  }
  .topUPBtn{
    padding: 15px;
    text-align: center;
    color:red;
    font-size:20px;
    cursor:pointer;
    border-radius:10px;
    bottom:100px;
    width:20%;
    left: 40%;
    position:absolute;
    /*margin: 0 auto;*/
    background: #f8e178
  }
</style>
<style>
.container1 {
  height: 200px;
  position: relative;
  border: 3px solid green;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 60%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

</style>



// WEBPACK FOOTER //
// src/components/popcontent1.vue